import React from 'react';
import './ActionDialog.css';

const ActionDialog = ({children, headerTxt}) => (
    <div className="action_dialog">
        <div className="action_dialogHeader">{headerTxt}</div>
        <div className="action_dialogBody">{children}</div>
    </div>
)
export default ActionDialog


// WEBPACK FOOTER //
// ./src/RollResults/ActionBar/ActionDialog.js